import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { Form, Field } from "@xo-union/tk-component-fields";
import { FormBlockColumn } from "@xo-union/tk-component-form-grid";
import BrandLogo from "@xo-union/component-brand-logo";
import { useTrackImpression } from "@xo-union/tk-component-analytics";
import BlankButton from "@xo-union/component-blank-button";
import { ModalHeader } from "@xo-union/ui-accessibility";
import { InlineAlert } from "@xo-union/tk-component-alerts";
import { compose } from "@xo-union/react-css-modules";
import mapPropsToAnalyticsData from "./mapPropsToAnalyticsData/index.js";
import FormSubmitButton from "../Buttons/index.js";
import styles from "../../css/index.css";
import generateFormLinks from "../../utils/generateFormLinks/index.js";

const FormHeader = () => /*#__PURE__*/React.createElement(ModalHeader, {
  className: styles.logInHeader
}, "Log in to", /*#__PURE__*/React.createElement(BrandLogo, {
  className: styles.logo,
  name: "theknot",
  size: "lg",
  color: "primary"
}));

const FormFooter = _ref => {
  let {
    onClickSignUp
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, "Are you a vendor? \xA0", /*#__PURE__*/React.createElement("a", {
    className: styles.footerLink,
    href: "https://www.theknot.com/vendors/home?itm_source=theknot.com&itm_medium=referral&itm_campaign=log-in-modal"
  }, "Log in here"), /*#__PURE__*/React.createElement("hr", null), "Not a member yet? \xA0", /*#__PURE__*/React.createElement(BlankButton, {
    className: styles.footerLink,
    onClick: onClickSignUp,
    type: "button"
  }, "Join now")));
};

process.env.NODE_ENV !== "production" ? FormFooter.propTypes = {
  onClickSignUp: PropTypes.func.isRequired
} : void 0;

const LogInForm = props => {
  useTrackImpression(mapPropsToAnalyticsData(props));
  const links = generateFormLinks();
  const {
    onClickSignUp,
    onSubmit,
    inProgress,
    Footer,
    Header,
    initialFocusRef,
    emailProps,
    passwordProps,
    alertProps
  } = props;
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');

  const handleSubmit = (evt, originalEvent) => {
    const data = {
      email,
      password
    };
    onSubmit({ ...evt,
      data
    }, originalEvent);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.formContainer
  }, /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement(InlineAlert, _extends({
    classes: compose({
      container: styles.formAlert
    }),
    type: "error",
    visible: false
  }, alertProps), typeof (alertProps === null || alertProps === void 0 ? void 0 : alertProps.children) === 'function' ? alertProps.children(alertProps.data) : (alertProps === null || alertProps === void 0 ? void 0 : alertProps.data) || 'Something went wrong. Please try again.'), /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    "aria-busy": inProgress ? 'true' : undefined,
    "aria-label": "log in"
  }, /*#__PURE__*/React.createElement(FormBlockColumn, null, /*#__PURE__*/React.createElement(Field, _extends({
    value: email,
    onChange: evt => setEmail(evt.target.value),
    name: "email",
    type: "email",
    validations: {
      required: true
    },
    ref: initialFocusRef,
    label: "Email Address",
    autoComplete: "email"
  }, emailProps))), /*#__PURE__*/React.createElement(FormBlockColumn, null, /*#__PURE__*/React.createElement(Field, _extends({
    value: password,
    onChange: evt => setPassword(evt.target.value),
    validations: {
      required: true
    },
    name: "password",
    type: "password",
    autoComplete: "current-password"
  }, passwordProps))), /*#__PURE__*/React.createElement(FormSubmitButton, {
    isLoading: inProgress
  }, "Log In")), /*#__PURE__*/React.createElement("div", {
    className: styles.formSubText
  }, /*#__PURE__*/React.createElement("a", {
    className: styles.forgotPwd,
    href: links.FORGOT_PASSWORD
  }, "Forgot your password?")), /*#__PURE__*/React.createElement(Footer, {
    onClickSignUp: onClickSignUp
  }));
};

process.env.NODE_ENV !== "production" ? LogInForm.propTypes = {
  /**
   * Evoked when clicking on 'Sign Up'
   */
  onClickSignUp: PropTypes.func.isRequired,

  /**
   * Form submission callback
   */
  onSubmit: PropTypes.func.isRequired,

  /**
   * To indicate that an API is processing
   */
  inProgress: PropTypes.bool,

  /**
   * Footer section component
   */
  Footer: PropTypes.func,

  /**
   * Header section component
   */
  Header: PropTypes.func,

  /**
   * Element to set as the initial focus
   */
  initialFocusRef: PropTypes.shape({
    current: PropTypes.shape()
  }),

  /**
   * Used to set additional props on the email field
   */
  emailProps: PropTypes.shape(),

  /**
   * Used to set additional props on the password field
   */
  passwordProps: PropTypes.shape(),

  /**
   * Used to set additional props on the alert
   */
  alertProps: PropTypes.shape()
} : void 0;
LogInForm.defaultProps = {
  inProgress: false,
  Footer: FormFooter,
  Header: FormHeader,
  emailProps: {},
  passwordProps: {}
};
export default LogInForm;